import { styled } from '@stitches/react';

const Box = styled('div', {});

export default Box;
